import { Component, Input, OnInit, ElementRef } from '@angular/core';

@Component({
  selector: 'app-comments-modal',
  templateUrl: './comments-modal.component.html',
  styleUrls: ['./comments-modal.component.css']
})
export class CommentsModalComponent implements OnInit {
  @Input() commentData: any;
  isLoading = true;
  constructor(public el: ElementRef) { }

  ngOnInit(): void {
    ($(this.el.nativeElement).find('#commentsModal') as any).on('hidden.bs.modal', () => {
      this.isLoading = true;
      this.commentData = null;
    });
  }

  open(commentData: any) {
    this.isLoading = true;
    this.commentData = null;
    ($(this.el.nativeElement).find('#commentsModal') as any).modal('show');

    setTimeout(() => {
      this.commentData = commentData;
      this.isLoading = false;
    }, 300);
  }
}
